import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "react-bootstrap/Table";
import theme from "../../../Utils/theme";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import deleteIcon from "../../../assets/icon/trash-solid.svg";
import Fontstyling, { tablestyle } from "../../../components/common/comman";
import CarrierModal from "../../../components/common/Modal/MedicalCredentialModal";
import {
  DeleteMedicalCarrierData,
  GetMedicalCarrierData,
} from "../../../api/User/Hub/medicalcredentialsApi";
import CryptoJS from "crypto-js";
import "react-toastify/dist/ReactToastify.css";
import eyesolid from "../../../assets/icon/eye-solid.svg";
import eyeSlash from "../../../assets/icon/eye-slash-solid.svg";
import Loader from "../../../components/common/Loader";
import NoDataMassage from "../../../components/common/NoDataMassage";
import toastFile from "../../../Service/ToastFile";
import DetailsHeader from "../../../components/common/Hub/DetailsHeader";

const MedicalCredentials = ({ navigate }) => {
  const user = useSelector((state) => state.userDetails.value);
  const client = useSelector((state) => state.clientData.value);
  const [isLoading, setIsLoading] = useState(false);
  const [medicalCarrierData, setMedicalCarrierData] = useState([]);
  const [witchAction, setWitchAction] = useState("add");
  const [updateData, setUpdateData] = useState({});
  const [responseMessage, setResponseMessage] = useState("");
  const [password, setPassword] = useState({
    id: -1,
    text: "",
  });
  const tableHeaderStyle = {
    background: theme.SECONDARY_CLASSIC_DARK,
    color: theme.SECONDARY_EGGSHELL_WHITE,
  };

  const [modalShow, setModalShow] = useState(false);
  useEffect(() => {
    getCarrierData();
  }, []);

  useEffect(() => {
    if (responseMessage !== "") {
      if (responseMessage === "rejectedRegion") {
        toastFile("Region Rejected");
      } else {
        toastFile(responseMessage, "success");
      }
    }
    getCarrierData();
    setResponseMessage("");
  }, [responseMessage, client]);

  const getCarrierData = () => {
    if (client !== null) {
      setIsLoading(true);
      GetMedicalCarrierData(client?.clientID, user?.UD_id)
        .then((res) => {
          if (res?.status === 200 || res?.status === 204) {
            setIsLoading(false);
            setMedicalCarrierData(res.data);
          }
        })
        .catch((err) => setIsLoading(false));
    }
  };

  const deleteMedicalCarrier = (MedCarId) => {
    let payload = {
      MedCarID: MedCarId,
    };
    DeleteMedicalCarrierData(payload).then((res) => {
      if (res?.status === 200 || res?.status === 204) {
        setResponseMessage(res.data);
      }
    });
  };

  const handelShowPassword = (id, value, action) => {
    if (action === "show") {
      const bytes = CryptoJS.AES.decrypt(value, process.env.REACT_APP_AES_KEY);
      const text = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      setPassword({
        id: id,
        text: text,
      });
    } else {
      setPassword({
        id: -1,
        text: "",
      });
    }
  };

  return (
    <>
      <CarrierModal
        show={modalShow}
        onHide={() => {
          setUpdateData({});
          setModalShow(false);
        }}
        witchAction={witchAction}
        user={user}
        client={client}
        updateData={updateData}
        setResponseMessage={setResponseMessage}
        deleteMedicalCarrier={deleteMedicalCarrier}
        getData={getCarrierData}
      />
      <DetailsHeader
        setModalShow={setModalShow}
        setWitchAction={setWitchAction}
        page={"credential"}
      />
      <div className="mt-4">
        <div className="mb-2" style={Fontstyling.heading}>
          Medical Carrier Credentials:
        </div>
        <p style={Fontstyling.primaryparagraph}>
          To successfully create the proper data feeds and import processes, the
          information provided must be accurate and updated whenever there is a
          change to any of the required data elements below. Inaccurate,
          incorrect, and/or missing required data fields may result in an import
          error, which will create issues in the Fusion for Snapshot 360.
        </p>
        <p style={Fontstyling.primaryparagraph}>
          <strong> Note: </strong>
          If you change the password on the carrier’s web portal, you must also
          change the password listed in the medical credentials table below in
          order to prevent an error in the import process. If the user name and
          password is not associated with your name, you must have written
          and/or documented authorization to use such credentials prior to
          establishing the data connection.
        </p>
        <p style={Fontstyling.primaryparagraph}>
          There may be different website links that point to different reports
          that are required in order to populate Snapshot 360 and
          underwriting calculators in their entirety. Please be specific and
          ensure you have requested each report as required (i.e., membership or
          eligibility, medical or pharmacy claims, high-cost claimants, pharmacy
          rebates, capitation fees, etc.)
        </p>
      </div>
      <div>
        <Table
          responsive
          bordered
          className="m-0"
          //size="sm"
          style={{ fontSize: "12px" }}
        >
          <thead
            className="py-2"
            style={{
              background: theme.SECONDARY_CLASSIC_DARK,
              color: theme.SECONDARY_EGGSHELL_WHITE,
              ...tablestyle.tableheading,
            }}
          >
            <tr>
              <th style={tableHeaderStyle}>Carrier</th>
              <th style={tableHeaderStyle}>Authorized User</th>
              <th style={tableHeaderStyle}>Carrier Website</th>
              <th style={tableHeaderStyle}>File Type</th>
              <th style={tableHeaderStyle}>User Name</th>
              <th style={tableHeaderStyle}>Password</th>
              <th style={tableHeaderStyle}>Last Import Date</th>
              <th style={tableHeaderStyle}>Dashboard Date</th>
              <th style={tableHeaderStyle} className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody style={tablestyle.tabledata}>
            {medicalCarrierData.length && !isLoading
              ? medicalCarrierData.map((item, index) => (
                  <tr>
                    <td>{item.CarrierName}</td>
                    <td>{item.UD_emp_name}</td>
                    <td>{item.Website}</td>
                    <td>{item.FileTypeName}</td>
                    <td>{item.UserName}</td>
                    <td style={{ minWidth: "125px" }}>
                      <div className="d-flex align-items-center justify-content-around">
                        <div style={{ width: "90%" }}>
                          {password.id === item.MedCarId
                            ? password.text
                            : "******"}{" "}
                        </div>
                        {password.id === item.MedCarId ? (
                          <img
                            src={eyeSlash}
                            width="11"
                            alt="eye icon"
                            className="cursor-pointer"
                            onClick={() =>
                              handelShowPassword(
                                item.MedCarId,
                                item.Password,
                                "hide"
                              )
                            }
                          />
                        ) : (
                          <img
                            src={eyesolid}
                            width="11"
                            alt="eye icon"
                            className="cursor-pointer"
                            onClick={() =>
                              handelShowPassword(
                                item.MedCarId,
                                item.Password,
                                "show"
                              )
                            }
                          />
                        )}
                      </div>
                    </td>

                    <td>{item.LastImportDate}</td>
                    <td>{item.DashboardDate}</td>
                    <td className="d-flex align-items-center justify-content-evenly">
                      <img
                        src={editIcon}
                        width="11"
                        className="py-1 cursor-pointer"
                        alt="edit icon"
                        onClick={() => {
                          const bytes = CryptoJS.AES.decrypt(
                            item?.Password,
                            process.env.REACT_APP_AES_KEY
                          );
                          const text = JSON.parse(
                            bytes.toString(CryptoJS.enc.Utf8)
                          );
                          setUpdateData({ ...item, Password: text });
                          setWitchAction("update");
                          handelShowPassword(
                            item.MedCarId,
                            item.Password,
                            "hide"
                          );
                          setModalShow(true);
                        }}
                      />
                      <img
                        src={deleteIcon}
                        width="10"
                        className="py-1 cursor-pointer"
                        alt="delete icon"
                        onClick={() => {
                          setWitchAction("delete");
                          setModalShow(true);
                          setUpdateData(item);
                        }}
                      />
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        {isLoading ? (
          <Loader />
        ) : medicalCarrierData.length === 0 ? (
          <NoDataMassage massage="No records to display" />
        ) : null}
      </div>

      <div className="d-md-flex d-block align-items-center gap-3 mt-3">
        <button
          className="text-nowrap"
          style={Fontstyling.savebutton}
          onClick={() => navigate("/HUBExperience/dentalplansetup")}
        >
          Save & Continue
        </button>
        {/* <button style={Fontstyling.cancelbutton} type="reset">
          Cancel
        </button> */}
        <div style={Fontstyling.secondaryparagraph}>
          To edit pre-populated company information, please make changes in
          BenefitPoint and return to Infused Analytics
        </div>
      </div>
      {/* <div style={Fontstyling.primaryparagraph}>
        Showing 1 to 4 of 4 entries
      </div> */}
    </>
  );
};

export default MedicalCredentials;
